<template>
  <div>
    <b-form class="col-lg-12" ref="myProfileForm" @submit="onSubmit" style="padding-left: 0px;">

      <b-row>
      <b-col lg="4">

      <b-row>
      <b-col>
      <b-form-group id="usernameGroup">
        <span class="fieldHeader">{{$t('privatePage.username')}}:</span>
        <b-row style="padding-top: 5px;">
          <b-col>
            <span> {{ this.currentUser.userName }} </span>
          </b-col>
        </b-row>
      </b-form-group>
      </b-col>

      <b-col style="text-align: right">
        <b-form-group id="companyInformationGroup">
          <span class="fieldHeader">{{$t('privatePage.company')}}:</span>
            <b-row style="padding-top: 5px;">
              <b-col>
                <span class="d-block">{{ this.company.name }}</span>
                <span class="d-block">{{ this.company.organisationNumber }}</span>
                <span class="d-block">{{ this.company.credits }} {{$t('privatePage.credits_inline')}}</span>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group id="emailGroup">
        <span class="fieldHeader">{{$t('privatePage.email')}}:</span>
        <b-form-input id="emailInput"
                      type="email"
                      v-model="currentUser.email"
                      required>
        </b-form-input>
      </b-form-group>

      <b-form-group id="languageGroup">
        <span class="fieldHeader">{{$t('privatePage.language')}}:</span>
        <b-form-select id="languagePicker"
                       :options="languages"
                       value-field="languageId"
                       text-field="langName"
                       v-model="currentUser.languageId"
                       required>
        </b-form-select>
      </b-form-group>

      <b-form-group id="savePasswordGroup">
        <b-form-checkbox id="passwordCheckbox"
                        v-model="savePassword">
          {{ $t('privatePage.password_change') }}
        </b-form-checkbox>
      </b-form-group>

      <b-form-group id="passwordGroup"
                    v-show="savePassword">
        <span class="fieldHeader">{{$t('privatePage.password')}}:</span>
        <b-form-input id="passwordInput"
                      type="password"
                      v-model="currentUser.password"
                      :required="currentUser.savePassword" >
        </b-form-input>
      </b-form-group>

      <b-form-group id="passwordGroup2"
                    v-show="savePassword">
        <span class="fieldHeader">{{$t('privatePage.password_confirm')}}:</span>
        <b-form-input id="passwordInput2"
                      type="password"
                      v-model="currentUser.password2"
                      :required="currentUser.savePassword" >
        </b-form-input>
      </b-form-group>

      </b-col>
      </b-row>

      <b-button type="submit" class="me-1" ref="submitButton">{{ $t('save') }}</b-button>
      <b-button type="button" ref="cancelButton" variant="danger" v-on:click="onCancel">{{ $t('cancel') }}</b-button>
    </b-form>

    </div>
</template>

<script>
export default {
  name: 'my-profile-editor',
  data() {
    return {
      savePassword: false
    }
  },
  props: {
    company: {},
    languages: {},
    currentUser: {}
  },
  computed: {
    deleteUserConfirmation() {
      return this.$t('privatePage.userDelete_confirmation')
    },
    passwordMismatchMessage() {
      return this.$t('privatePage.password_mismatch')
    },
    passwordWrongFormatMessage() {
      return this.$t('privatePage.password_wrongFormat')
    }
  },
  methods: {
    validateForm: function() {
      if (this.savePassword) {
        if (this.currentUser.password !== this.currentUser.password2) {
          this.alerts.warningMessage = this.passwordMismatchMessage
          this.alerts.warningCountdown = this.alerts.dismissSecs
          return false
        }

        var re = /^(?!^[0-9]*$)(?!^[a-zA-Z]*$)^([a-zA-Z0-9]{6,14})$/
        if (!re.test(this.currentUser.password)) {
          this.alerts.warningMessage = this.passwordWrongFormatMessage
          this.alerts.warningCountdown = this.alerts.dismissSecs
          return false
        }
      }
      return true
    },
    onSubmit: function(evt) {
      evt.preventDefault()
      let user = this.currentUser
      user.savePassword = this.savePassword

      if (this.validateForm()) {
        this.$emit('formSubmitted', user)
      }
    },
    onCancel: function(evt) {
      this.$router.go(-1)
    }
  }
}
</script>
